import React, { Component } from 'react';
import { TextInput } from '../components/TextInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import axios from 'axios';

interface IProps {
    gtmEvent(): void;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    email?: string;
    name?: string;
    status: 'open'|'unsubscribing'|'unsubscribed';
}

export class UnsubscribeNewsletter extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {status: 'open', hasError: false};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    submit() {
        var errors:string[]=[];
        if (!this.state.email) {
            errors.push("Email is required");
        }
        if (errors.length > 0) {
            this.setState({errors: errors, hasError: true});
            return;
        }
        var lead:any = {emailApplicant1: this.state.email};
        
        this.setState({status: 'unsubscribing'});
        axios.post("/lead/unsubscribe", lead)
        .then((response) => {
            this.setState({status: 'unsubscribed'});
        })
        .catch((error) => {
            //alert('submit error: ' + error.message);
        });
    }

    render() {

        return (
            <header className="App-header bgchartreuse">
                <h1 className='l'>Unsubscribe</h1>
                {this.state.status === 'open' &&
                <>
                <p>We're so sorry to see you go! To unsubscribe from our emails enter your email address below</p>
                <div className='wrapper'>
                    <div className='row justify-c'>

                        <div className='column3'>
                            <TextInput
                                id='email'
                                value={this.state.email}
                                placeholder='Email Address'
                                classes={`${this.state.hasError && !this.state.email ? "e" : ""} tight`}
                                onChange={(e) => { this.setState({email: e.target.value}); }} />
                        </div>
                        <NextButton customLabel='Submit' type='tertiary' onClick={() => this.submit()} />
                    </div>
                    {this.state.hasError &&
                        <ErrorBox hideTitle={true} errors={this.state.errors!} />
                    }
                </div>
                </>
                }
                {this.state.status === 'unsubscribing' &&
                <div className='loading-spinner-nodelay'/>
                }
                {this.state.status === 'unsubscribed' &&
                <p>You have been unsubscribed.</p>
                }
            </header>
        );
    }
}
